// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t8-0";